/**
 * Looks like a button should act like a button.
 *
 * {@link https://jira.walmart.com/browse/LD-374?focusedCommentId=12802856&page=com.atlassian.jira.plugin.system.issuetabpanels%3Acomment-tabpanel#comment-12802856}
 * @param anchorProps
 * @private
 */
var onAnchorKeyDown = function onAnchorKeyDown(anchorProps) {
  var href = anchorProps.href,
    onClick = anchorProps.onClick,
    onKeyDown = anchorProps.onKeyDown;
  return function (event) {
    onKeyDown === null || onKeyDown === void 0 || onKeyDown(event);
    if (event.defaultPrevented || event.key !== ' ') {
      return;
    }
    onClick === null || onClick === void 0 || onClick(event);

    // anchorProps.onClick could call preventDefault
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (event.defaultPrevented || !href) {
      return;
    }
    window.location.assign(href);
  };
};

export { onAnchorKeyDown };
